export const TAB_INDEX_FOCUS_WITH_JS_ONLY = -1;
